export default {
  /**
   * The label (basically the text that goes inside) of the checkbox.
   * The value for the label will be used as raw HTML, that is, you
   * can use <b>, <em> or <i> tags to stylize the content.
   */
  label: {
    type: String,
    default: '',
  },

  /**
   * The value of the checbox, can be either `true` or `false`.
   */
  value: {
    required: true,
    validator: prop => typeof prop === 'boolean' || !prop
  },

  /**
   * Tooltip directive value
   */
  tooltip: {
    type: [ Object, String ],
    default: null,
  },

  /**
   * The name of the field.
   */
  fieldName: {
    type: String,
    default: ''
  },

  disabled: {
    type: Boolean,
    default: false
  }
}
